/**
 * Stop pointer events on a DOM-layer element from also reaching the game underneath.
 *
 * Phaser's input manager listens on `window`, not only on the canvas (that is how it notices a
 * release that happens off-canvas). So a tap on one of our HTML controls bubbles up and Phaser
 * still processes it as a tap on the scene at those coordinates. Mostly harmless — but the
 * Summary screen routes ANY click outside its Replay button to the Menu, so without this,
 * dismissing the buy card with "Not now" also quit the summary.
 *
 * `click` is deliberately left alone: Phaser never uses it, and it is what drives our own
 * buttons and the store badges' `<a>` navigation.
 */
const SEALED_EVENTS = [
  'pointerdown', 'pointerup', 'pointercancel',
  'mousedown', 'mouseup',
  'touchstart', 'touchend',
] as const;

export function sealFromPhaser(el: HTMLElement): void {
  for (const type of SEALED_EVENTS) {
    el.addEventListener(type, (e) => e.stopPropagation());
  }
}
